module.exports = __webpack_public_path__ + "img/04_cg.918bda14.png";